import { setToken, removeToken } from '@/utils/auth'
import { setStore } from '@/utils/store'

const mutations = {
    SET_TOKEN: (state, token = null) => {
        state.token = token
        if (token) {
            setToken(token)
        } else {
            removeToken()
        }
    },
    SET_USERINFO: (state, userInfo) => {
        state.userInfo = userInfo
        setStore({
            name: 'userInfo',
            content: state.userInfo
        })
    },
    SET_LOGIN_USER_DEPT_INFO: (state, deptInfo) => {
        state.loginUserDept = deptInfo
        setStore({
            name: 'loginUserDept',
            content: state.loginUserDept
        })
    },
    SET_MENU: (state, menu) => {
        state.menu = menu
        setStore({
            name: 'menu',
            content: state.menu,
            type: 'session'
        })
    },
    SET_MENU_ALL: (state, menuAll) => {
        state.menuAll = menuAll
    },
    SET_PERMISSION: (state, permission) => {
        state.permission = {}
        permission.forEach(ele => {
            ele.split(',').map(row => {
                let els = row.split(':')
                if (els.length > 2) {
                    state.permission[`${els[1]}_${els[2]}`] = true
                }
            })
        })
        setStore({
            name: 'permission',
            content: state.permission,
            type: 'session'
        })
    },
    DEL_ALL_TAG: () => { },
    CLEAR_LOCK: () => { }
}

export default mutations
